<div #mainContainer class="content" tabindex="0" (keyup)="handleKeyUp($event)">
  <div class="header">
    <mat-card-title>{{data.title}}</mat-card-title>
    <mat-card-subtitle *ngIf="data.subtitle">{{data.subtitle}}</mat-card-subtitle>
  </div>

  <div class="body">
    <div class="message mt-4" [innerHTML]="getMessageSinitized()"></div>

    <span *ngFor="let input of data.inputs">

    </span>

  </div>

  <div class="actions" [ngClass]="getButtonsClass()">
    <button mat-icon-button *ngIf="data.clipboard" (click)="copyToClipboard()">
      <mat-icon>content_copy</mat-icon>
    </button>
    <button #actionButtons mat-button *ngFor="let button of data.buttons" [color]="button.color"
      (click)="handleButton(button)">{{button.text}}</button>
  </div>

</div>
